<template>
    <div class="cusModal" v-if="showtable">
        <div class="cusModalCont">
            <div class="cusModalTitle blackBack"> {{ title }}
                <div class="eportBtn">
                    <div>تصدير PDF</div>
                    <div>تصدير Excel</div>
                    <div>طباعة</div>
                </div>
                <div class="cusModalClose" @click="closeTable()">{{ lang.close }}</div>
            </div>
            <div class="cusModalBody">
                <h5 class="blackBack text-align:center" v-if="tbrows.length != 0">فواتير المبيعات</h5>
                <v-simple-table class="mt-1" :style="`padding-inline:40px;direction: ${lang.dir};`" v-if="tbrows.length != 0">
                    <thead>
                        <tr>
                            <th class="backBlack text-center">رقم الفاتورة</th>
                            <th class="backBlack text-center">نوع العميل</th>
                            <th class="backBlack text-center">اسم العميل</th>
                            <th class="backBlack text-center">رقم الاتصال</th>
                            <th class="backBlack text-center">الاجمالي</th>
                            <th class="backBlack text-center">{{ lang.vat }}</th>
                            <th class="backBlack text-center">{{ lang.ftotal }}</th>
                            <th class="backBlack text-center">{{ lang.paid }}</th>
                            <th class="backBlack text-center">{{ lang.remain }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in tbrows" :key="index">
                            <td class="text-center">{{item.invoice_number}}</td>
                            <td class="text-center">{{item.customerType}}</td>
                            <td class="text-center">{{item.customer_name}}</td>
                            <td class="text-center">{{$RoundNums(item.mobile,2)}}</td>
                            <td class="text-center">{{$RoundNums(item.total,2)}}</td>
                            <td class="text-center">{{$RoundNums(item.vat,2)}}</td>
                            <td class="text-center">{{$RoundNums(item.ftotal,2)}}</td>
                            <td class="text-center">{{$RoundNums(item.paid,2)}}</td>
                            <td class="text-center" >{{$RoundNums(item.remain,2)}}</td>
                        </tr>
                    </tbody>
                    
                </v-simple-table>
                <h5 class="blackBack mt-2 text-align:center" v-if="tbExpens.length != 0">فواتير المصروفات</h5>
                <v-simple-table class="mt-1" :style="`padding-inline:40px;direction: ${lang.dir};`" v-if="tbExpens.length != 0">
                    <thead>
                        <tr>
                            <th class="backBlack text-center">تاريخ الفاتورة</th>
                            <th class="backBlack text-center">رقم الفاتورة</th>
                            <th class="backBlack text-center">اسم الشركة</th>
                            <th class="backBlack text-center">الرقم الضريبي</th>
                            <th class="backBlack text-center">الاجمالي</th>
                            <th class="backBlack text-center">{{lang.vat}}</th>
                            <th class="backBlack text-center">{{lang.ftotal}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in tbExpens" :key="index">
                            <td class="text-center">{{item.bill_date}}</td>
                            <td class="text-center">{{item.bill_number}}</td>
                            <td class="text-center">{{item.vendor}}</td>
                            <td class="text-center">{{item.vatid}}</td>
                            <td class="text-center">{{item.total}}</td>
                            <td class="text-center">{{item.vat}}</td>
                            <td class="text-center">{{item.ftotal}}</td>
                        </tr>
                    </tbody>
                    
                </v-simple-table>

                <h5 class="blackBack mt-2 text-align:center" v-if="tbPurch.length != 0">فواتير المشتريات</h5>
                <v-simple-table class="mt-1" :style="`padding-inline:40px;direction: ${lang.dir};`" v-if="tbPurch.length != 0">
                    <thead>
                        <tr>
                            <th class="backBlack text-center">تاريخ الفاتورة</th>
                            <th class="backBlack text-center">رقم الفاتورة</th>
                            <th class="backBlack text-center">اسم الشركة</th>
                            <th class="backBlack text-center">الرقم الضريبي</th>
                            <th class="backBlack text-center">الاجمالي</th>
                            <th class="backBlack text-center">{{lang.vat}}</th>
                            <th class="backBlack text-center">{{lang.ftotal}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in tbPurch" :key="index">
                            <td class="text-center">{{item.bill_date}}</td>
                            <td class="text-center">{{item.bill_number}}</td>
                            <td class="text-center">{{item.vendor}}</td>
                            <td class="text-center">{{item.vatid}}</td>
                            <td class="text-center">{{item.total}}</td>
                            <td class="text-center">{{item.vat}}</td>
                            <td class="text-center">{{item.ftotal}}</td>
                        </tr>
                    </tbody>
                    
                </v-simple-table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default{
    data() {
        return {
            title: 'قائمة الفواتير',
            showtable: false,
            tbrows: [],
            search: {
                sdate: '',
                edate: '',
            },
            tbExpens: [],
            tbPurch: [],
        }
    },
    computed:{
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        totals: function(){
            let t = {
                total: 0, qty: 0, current: 0
            }
            for(let i=0;i<this.tbrows.length;i++){
                t.qty = parseFloat(t.qty) + parseFloat(this.tbrows[i].qtty)
                t.total = parseFloat(t.total) + parseFloat(this.tbrows[i].total)
                t.current = parseFloat(t.current) + parseFloat(this.tbrows[i].current)
            }
            return t;
        },
    },
    methods: {
        closeTable(){
            this.title = '',
            this.showtable = false;
            this.tbrows = []
            this.search = {
                sdate: '',
                edate: '',
            }
        },
        getReport(option) {
            // if(option.type == 2){
            //     this.title = 'فواتير اجلة';
            // }
            // if(option.type == 1){
            //     this.title = 'فواتير نقدية';
            // }
            // if(option.type == 3){
            //     this.title = 'مرتجع الفواتير';
            // }
            // if(option.paid == 1){
            //     this.title = 'التحصيل';
            // }
            if(option.type != 5){
                this.title = "ضريبة " + option.name
            }else{
                this.title = option.name
            }
            this.showtable = true;
            const post = new FormData();
            post.append('type','getInvoiceVatDashboard');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[options]',JSON.stringify(option));
            post.append('data[getAll]',1)
           
            this.tbrows = [];
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                this.tbrows = response.data.results.data;
                this.tbExpens = response.data.results.tbExpens;
                this.tbPurch = response.data.results.tbPurch;
            })
        }
    },
    created() {
        //
    },
}
</script>
<style scoped>
.cusModal{
    position: fixed;
    background:#0000001a;
    top:0;
    left:0;
    bottom:0;
    right:0;
    z-index: 20000000;
    display:flex;
    justify-content: center;
    justify-items: center;
    align-items: center;;
}
.cusModalCont{
    position:relative;
    width:70%;
    height: 70vh;
    border:1px solid #bbb;
    background:#fff;
    box-shadow: 0px 1px 1px 1px #0000001a;
    border-radius: 5px;
}
.eportBtn{
    position: absolute;
    top:2px;
    left:60px;
    border:1px solid #555;
    border:#ccc;
    border-radius: 2px;
    padding:4px 10px;
    cursor: pointer;
    box-shadow: 0px 1px 1px 1px #0000001a;
    display:flex;
    justify-content: space-between;
    justify-items: center;
    align-items: center;
}
.eportBtn div{
    padding:2px 5px;
    width:80px;
    font-size:.8rem;
    background:blue;
    margin-inline-start:5px;
    color:#fff;
    border-radius: 3px;
}
.cusModalClose{
    position: absolute;
    top:2px;
    left:10px;
    background:red;
    color:#fff;
    border:1px solid #555;
    border:#ccc;
    border-radius: 2px;
    padding:4px 10px;
    cursor: pointer;
    box-shadow: 0px 1px 1px 1px #0000001a;
}
.cusModalCloseL:hover{
    background: darkred;
}
.cusModalTitle{
    padding:5px;
    text-align:center;
    border-color: #bbb !important;
    border-bottom-color: #000 !important;
}
.cusModalBody{
    overflow: auto;
    height:calc(70vh - 50px);
    max-height:calc(70vh - 50px);
    padding:5px;
}
</style>

